import React from 'react';
import Icon from '../../design-system/icon.jsx';

export const TrustBadges = ({ isFreeShipping }) => (
  <div className="cart-popup__trust-badges">
    {isFreeShipping && (
      <div className="cart-popup__trust-badges-text">
        <Icon type="shipping-truck" />
        <span>Free U.S Shipping</span>
      </div>
    )}
    <div className="cart-popup__trust-badges-text">
      <Icon type="shield" />
      <span>60-Day Money Back</span>
    </div>
  </div>
);
